<div fxFlexFill fxLayout="column nowrap">
  <ng-content>

  </ng-content>
</div>
